import FontBody1 from "../../../fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../fonts/font-props";
import { BUTTON_VARIANTS } from "../../../inputs/button-variants";
import { Button } from "../../../inputs/button/button";
import { DefaultModalLayout } from "../../layouts/default-modal-layout";

import './confirm-modal.scss';

interface IConfirmModalProps {
    title?: React.ReactNode, 
    text?: React.ReactNode, 
    implicationText?: React.ReactNode, 
    questionText?: React.ReactNode, 
    isCloseDisabled?: boolean;
    cancelButton?: { 
        title: string, 
        onClick: () => void,
        disabled?: boolean,
    }, 
    okButton?: { 
        title: string, 
        onClick: () => void,
        variant?: BUTTON_VARIANTS,
        hasLoader?: boolean,
        isLoading?: boolean,
    }
}

export const ConfirmModal: React.FC<IConfirmModalProps> = ({
    title = 'Unsaved Changes',
    text = 'You have unsaved changes. Click discard to discard changes and continue or cancel to continue editing.',
    implicationText,
    questionText,
    isCloseDisabled,
    cancelButton = {
        title: 'Cancel',
        onClick: () => {},
    },
    okButton = {
        title: 'OK',
        onClick: () => {},
    }
}) => {
    return (
        <DefaultModalLayout onCloseClicked={() => cancelButton?.onClick()} isCloseDisabled={isCloseDisabled ?? false}>
            <div className="confirm-modal">
                {title && <div className="confirm-modal-title">
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>{ title }</FontBody1>
                </div>}
                <div className="confirm-modal-text">
                <FontBody1 color={FONT_COLOR.PRIMARY3}>{ text }</FontBody1>
                </div>
                {implicationText && <div className="confirm-modal-implication-text">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>{ implicationText }</FontBody1>
                </div>}
                {questionText && <div className="confirm-modal-question-text">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>{ questionText }</FontBody1>
                </div>}
                <div className="confirm-modal-buttons">
                    <Button text={cancelButton?.title} onClick={cancelButton?.onClick} disabled={cancelButton?.disabled} variant={BUTTON_VARIANTS.Tertiary} />
                    <Button text={okButton?.title} onClick={okButton?.onClick} variant={okButton?.variant || BUTTON_VARIANTS.Primary} hasLoader={okButton?.hasLoader} isLoading={okButton?.isLoading} />
                </div>
            </div>
        </DefaultModalLayout>
    );
}
